
export default {
  data: () => ({
    service_edit_index: -1,
    store: null,
    service: {
      name: null,
      address: null,
      phone_number: null,
      description: null,
      is_active: null,
      count: 0,
      workDays: [],
      fromTime: '',
      toTime: '',
    },
    services: [],
  }),
  methods: {
    async update_services() {
      const services = this.$communicator.then(this, await this.$communicator('services'))
      if (Array.isArray(services)) {
        this.services = this.$copy(services.map(service => ({
          ...service,
          is_active: service.is_active ? this.$t("active") : this.$t("inactive"),
        })))
      }
    },
    async edit_service(item) {
      if (Array.isArray(item.work_time) && item.work_time[0]) {
        this.workDays = item.work_time?.map(day => day.day);
        this.fromTime = item.work_time[0].from;
        this.toTime = item.work_time[0].to;
      } else {
        this.wordDays = [];
        this.fromTime = '';
        this.toTime = '';
      }

      if (item === null) {
        this.service = {
          name: null,
          type: 'shop',
          address: null,
          phone_number: null,
          description: null,
          count: 0
        }
        this.service_edit_index = -1
      }
      else {
        this.service = this.$copy(item)
        this.service_edit_index = this.service['_id']
        this.service.phone_number = this.$communicator.make_phone_number(this.service.phone_number)
        delete this.service['_id']
      }
    },
    async save_service() {
      const service = this.$copy(this.service)
      const workDays = this.workDays

      service.work_time = []

      for (const workDay of workDays) {
        service.work_time.push({
          day: workDay,
          from: this.fromTime,
          to: this.toTime,
        })
      }

      service.phone_number = this.$communicator.clear_phone_number(service.phone_number)
      if (this.service_edit_index == -1) {
        const save = this.$communicator.then(this, await this.$communicator('create_service', {
          params: service
        }))
        if (save.statusCode == 419) {
          this.$toast.error(`${save.error}`, { timeout: 2000 });
        } else {
          this.$toast.success("Success", { timeout: 2000 });
        }
      }
      else {
        this.$communicator.then(this, await this.$communicator('service_update', {
          arguments: [this.service_edit_index],
          params: service
        }))
        this.$toast.success("Success", { timeout: 2000 });
      }
      setTimeout(() => this.update_services(), 1000)
    },
    async remove_service() {
      await this.$communicator('delete_service', {
        arguments: [
          this.service_edit_index
        ]
      })
      this.$toast.success("Success", { timeout: 2000 });
      this.update_services()
    },
  },
  mounted() {
    this.update_services()
    // if (this.stores.length > 0)
    //   this.store = this.stores[0]
  },
  beforeMount() {
    this.store = this.$store.state.items_current_service;
    if (this.store && !this.store.name) {
      this.store.name = this.$t("all_stores");
    }
  },
  computed: {
    stores() {
      if (this.noAllStores) {
        return [...this.services]
      }
      const stores = [{ name: this.$t('all_stores'), _id: '' }, ...this.services]
      return stores
    }
  }
}
